import { FC } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/utils/tailwind/utils";

type DocumentVersionTagProps = {
  isLatestVersion: boolean;
  className?: string;
};

export const DocumentVersionTag: FC<DocumentVersionTagProps> = ({ isLatestVersion, className }) => {
  const { t } = useTranslation();
  return (
    <span className={`${cn("bg-secondary px-2 py-1 text-xs", className)}`}>
      {isLatestVersion && t("document_latest_version")}
      {!isLatestVersion && t("document_old_version")}
    </span>
  );
};
